function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5 22c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 013 20v-6h2v3h10V5H5v3H3V2c0-.55.196-1.02.587-1.413A1.926 1.926 0 015 0h10c.55 0 1.02.196 1.413.588C16.803.979 17 1.45 17 2v18c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0115 22H5zm0-3v1h10v-1H5zm3-4l-1.4-1.4L8.15 12H0v-2h8.15L6.6 8.4 8 7l4 4-4 4zM5 3h10V2H5v1z",
  fill: "#006DFF"
});

function SvgArrowPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgArrowPhone;